import { render, staticRenderFns } from "./modal_detalhe.vue?vue&type=template&id=a59e474a&scoped=true"
import script from "./modal_detalhe.vue?vue&type=script&lang=js"
export * from "./modal_detalhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59e474a",
  null
  
)

export default component.exports